import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { addEvaluation, getClassesAssignments, getClassesSprints, resetEvaluationStatus } from '../../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import '../index.css'


function ExtraEvaluationForm (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        reviewedStudent: "",
        message: "",
        assignment: "",
        loading: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        props.getClassesAssignments(props.user.classes);
        props.getClassesSprints(props.user.classes);
    }, []);

    const calculateIfOnTime = (dueDate) => {
        const assignmentDueDate = new Date(dueDate);
        const currentDateObject = new Date(Date.now());
        assignmentDueDate.setHours(0, 0, 0, 0);
        assignmentDueDate.setDate(assignmentDueDate.getDate() + 1);
        return currentDateObject <= assignmentDueDate;
    }

    const handleStudentDropdownChange = (studentId) => {
        setState({
            ...state,
            reviewedStudent: studentId,
        });
    }

    const handleAssignmentDropdownChange = (assignmentId) => {
        const newState = {assignment: assignmentId};
        const assignment = props.classAssignments && props.classAssignments.find(assignment => assignment._id === assignmentId);
        const sprint = props.sprints && props.sprints.find(sprint => sprint._id === assignment.sprint);
        newState.sprint = sprint;
        newState.answers = {};
        newState.ids = {sprintId: sprint._id};
        for (let i = 0; i < sprint.questionAnswerTypePairs.length; i++) {
            newState.answers[i + ":" + sprint.questionAnswerTypePairs[i].question] = "";
        }
        setState({...state, ...newState});
    }

    const getMappedStudents = () => {
        return props.classStudents && props.classStudents
            .sort((a, b) => {
                if(a.lastName.toLowerCase() < b.lastName.toLowerCase()) return -1;
                if(a.lastName.toLowerCase() > b.lastName.toLowerCase()) return 1;
                return 0;
            })
            .map((student, index) => {
            return (
                <MenuItem
                    key={index + student.firstName}
                    value={student.lastName + ", " + student.firstName}
                    primaryText={student.lastName + ", " + student.firstName}
                    id="reviewedStudent"
                    onClick={() => handleStudentDropdownChange(student._id)}
                />
            );
        })
    }

    const getMappedAssignments = () => {
        return props.classAssignments && props.classAssignments
            .filter(assignment => calculateIfOnTime(assignment.dueDate))
            .sort((a, b) => {
                if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                return 0;
            })
            .map((assignment, index) => {
            return (
                <MenuItem
                    key={index + assignment.name}
                    value={assignment.name}
                    primaryText={assignment.name}
                    id="assignment"
                    onClick={() => handleAssignmentDropdownChange(assignment._id)}
                />
            );
        })
    }

    const getMappedQuestionsAnswerPairs = () => {
        return state.sprint && state.sprint.questionAnswerTypePairs &&
            state.sprint.questionAnswerTypePairs.map((questionAnswer, index) => {
                if (questionAnswer.answer === "Text") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <TextField
                                hintText="Answer"
                                name={index + ":" + questionAnswer.question}
                                onChange={handleChange}
                                value={state[index + ":" + questionAnswer.question]}
                                multiLine={true}
                                rows={1}
                                style={{width: "90%", maxWidth: "500px"}}
                            />
                        </div>
                    )
                } else if (questionAnswer.answer === "Range") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="1"
                                            checked={state[index + ":" + questionAnswer.question] === "1"}
                                        />
                                    1
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="2"
                                            checked={state[index + ":" + questionAnswer.question] === "2"}
                                        />
                                    2
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="3"
                                            checked={state[index + ":" + questionAnswer.question] === "3"}
                                        />
                                    3
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="4"
                                            checked={state[index + ":" + questionAnswer.question] === "4"}
                                        />
                                    4
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="5"
                                            checked={state[index + ":" + questionAnswer.question] === "5"}
                                        />
                                    5
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="6"
                                            checked={state[index + ":" + questionAnswer.question] === "6"}
                                        />
                                    6
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="7"
                                            checked={state[index + ":" + questionAnswer.question] === "7"}
                                        />
                                    7
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="Yes"
                                            checked={state[index + ":" + questionAnswer.question] === "Yes"}
                                        />
                                        Yes
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="No"
                                            checked={state[index + ":" + questionAnswer.question] === "No"}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
    }

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const getStudentName = () => {
        const student = props.classStudents.find(student => student._id === state.reviewedStudent);
        return student ? student.lastName + ", " + student.firstName : "";
    }

    const getAssignmentName = () => {
        const assignment = props.classAssignments.find(assignment => assignment._id === state.assignment);
        return assignment ? assignment.name : "";
    }

    async function handleSubmit() {
        setState({
            ...state,
            loading: true
        });
        await props.resetEvaluationStatus();
        const questionAnswerPairs = []
        let entry;
        let pointsForReviewed = 0;
        if (state.reviewedStudent === "") {
            setState({
                ...state,
                message: "You must answer all of the questions.",
                loading: false
            })
            return
        }
        if (state.assignment === "") {
            setState({
                ...state,
                message: "You must answer all of the questions.",
                loading: false
            })
            return
        }

        for (let key in state.answers) {
            entry = state.sprint.questionAnswerTypePairs.find(pair => pair.question === key.split(":")[1])
            if (entry.answer === "Range") {
                pointsForReviewed += parseInt(state[key], 10)
                questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Range"})
            } else if (entry.answer === "Y/N") {
                questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Y/N"})
            } else {
                questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Text"})
            }
        }

        props.addEvaluation(
            {
                questionAnswerPairs,
                pointsForReviewed,
                assignment: state.assignment,
                status: "StudentSubmitted",
                nameOfReviewedStudent: getStudentName(),
                nameOfReviewingStudent: props.user.lastName + ", " + props.user.firstName,
                user: props.user._id,
                class: state.sprint.class,
                sprint: state.ids.sprintId,
                studentReviewed: state.reviewedStudent
            },
            props.reviewingEvaluations
        );
    }

    useEffect(() => {
        if (props.authErrCode.editEvals.status === 201) {
            props.resetEvaluationStatus();
            navigate("/student");
        }
    }, [props.authErrCode.editEvals.status]);

        let loading = state.loading;
        let message = state.message;
        if (props.authErrCode.editEvals.status === 500) {
            loading = false;
            message = "An error occurred, please try again. If the problem persists, save your answers in a separate file and try again later.";
        }

        if ((!props.sprints || props.sprints.length === 0) ||
            (!props.classAssignments || props.classAssignments.length === 0)) {
            return (
                <div className="evaluationForm">
                    <div className="backButton">
                        <Link to="/student">
                            <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                            Return to Dashboard
                        </Link>
                    </div>
                    <h2>There are not any available assignments for which to submit evaluations</h2>
                </div>
            )
        }

    return (
        <div className="evaluationForm">
            <div className="backButton">
                <Link to="/student">
                    <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Dashboard
                </Link>
            </div>
            <h1>{props.assignment.name} Survey</h1>
            <h2>Student Being Reviewed</h2>
            <SelectField
                hintText={"Student"}
                name="reviewedStudent"
                value={getStudentName()}
                iconStyle={{paddingLeft: "22px"}}
            >
                {getMappedStudents()}
            </SelectField>
            <br/>
            <SelectField
                hintText={"Assignment"}
                name="assignment"
                value={getAssignmentName()}
                iconStyle={{paddingLeft: "22px"}}
            >
                {getMappedAssignments()}
            </SelectField>
            <br/>
            {state.sprint && state.sprint.questionAnswerTypePairs.some(questionAnswerPair => questionAnswerPair.answer === "Range") &&
                <h3>(For scale questions, 1=Strongly Disagree, 7=Strongly Agree)</h3>}
            {getMappedQuestionsAnswerPairs()}
            {
                loading ?
                    <img src={"/loading.svg"} alt="Loading..."/>
                    :
                    <button className="pink" onClick={handleSubmit}>Save</button>
            }
            <p>{message}</p>
        </div>
    );
}

export default connect(state => state.root, { addEvaluation, getClassesAssignments, getClassesSprints, resetEvaluationStatus })(ExtraEvaluationForm);
